import PropTypes from "prop-types";

/**
 * A component containing a loader.
 * @param {props} Props Component props.
 * @example
 * <BallGridPulseLoader/>
 * <BallGridPulseLoader center={true}/>
 * <BallGridPulseLoader center={false}/>
 * <BallGridPulseLoader center={false} styles={css}/>
 * <BallGridPulseLoader styles={css}/>
 * <BallGridPulseLoader color="#fff"/>
 * <BallGridPulseLoader styles={css} color="#fff"/>
 * <BallGridPulseLoader center={true} styles={css} color="#fff"/>
 */
const BallGridPulseLoader = ({ center = false, styles = {}, color = "#fff" }) => {
	const style = center
		? {
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
				...styles
		  }
		: styles;

	return (
		<div className="ball-grid-pulse" style={style}>
			{new Array(9).fill("").map((x, i) => (
				<div key={i} style={{ backgroundColor: color }} />
			))}
		</div>
	);
};

BallGridPulseLoader.propTypes = {
	center: PropTypes.bool,
	styles: PropTypes.object,
	color: PropTypes.string
};

export default BallGridPulseLoader;
